var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFl3X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 300 300",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M40.38 218.31C40.38 200.37 54.94 185.81 72.88 185.81C90.82 185.81 105.38 200.37 105.38 218.31C105.38 236.25 90.82 250.81 72.88 250.81C54.94 250.81 40.38 236.25 40.38 218.31Z",
    id: "d1VXKmUdj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.62 218.31C204.62 203.13 216.94 190.81 232.12 190.81C247.3 190.81 259.62 203.13 259.62 218.31C259.62 233.49 247.3 245.81 232.12 245.81C216.94 245.81 204.62 233.49 204.62 218.31Z",
    id: "d2gxViTiM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.67 86.69C113.67 65.99 130.47 49.19 151.17 49.19C171.87 49.19 188.67 65.99 188.67 86.69C188.67 107.39 171.87 124.19 151.17 124.19C130.47 124.19 113.67 107.39 113.67 86.69Z",
    id: "c3a3G8aecz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.7 102.83L156.2 128.24L109.81 207.65L66.31 182.24L112.7 102.83Z",
    id: "aDs6sQLh"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8 203.52L204.62 203.52L204.62 233.1L101.8 233.1L101.8 203.52Z",
    id: "cSee0jEEA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1VXKmUdj",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeWidth: 20,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2gxViTiM",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeWidth: 14,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3a3G8aecz",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#FFFFFF",
    strokeWidth: 20,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aDs6sQLh",
    opacity: 1,
    fill: "#FFFFFF",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cSee0jEEA",
    opacity: 1,
    fill: "#FFFFFF",
    fillOpacity: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFl3X);
export default __webpack_public_path__ + "static/media/fl3x.e12a13f0b07d214826ba8c6c9708969f.svg";
export { ForwardRef as ReactComponent };